import { jwtDecode } from "jwt-decode"
import { faro } from "@grafana/faro-web-sdk"
import { LOG_LOGOUT_API, REFRESH_PING } from "../constant/Constants"
import Api from "./Api"

let isRefreshing = false
let lastRefreshTime = 0
let tokenCheckInterval = null
let tokenIssuedTime = Date.now()

export const pingLogin = (url) => {
   return Api.get(url, {
      headers: getAuthentiationHeaders(1),
   }).then((res) => {
      if (res.data.authToken !== null) {
         setTokenData(res.data)
         sessionStorage.setItem("freshLogin", true)
         sessionStorage.setItem("freshLogin1", true)
         return Promise.resolve(res)
      } else {
         return Promise.reject(res)
      }
   })
}

let lastActivityTime = 0

// Function to update last activity time
const updateLastActivity = () => {
   lastActivityTime = Date.now()
   localStorage.setItem("lastActivityTime", lastActivityTime.toString())
}

// Function to check if there was activity in first 55 minutes of current token
const wasActiveInFirst55Minutes = () => {
   const storedActivity = localStorage.getItem("lastActivityTime")
   const lastActivity = storedActivity ? parseInt(storedActivity) : lastActivityTime
   const storedTokenTime = localStorage.getItem("tokenIssuedTime")
   const tokenTime = storedTokenTime ? parseInt(storedTokenTime) : tokenIssuedTime

   // 🎯 CRITICAL: Check if user had ANY activity AFTER token was issued AND within first 55 minutes
   const fiftyFiveMinutesAfterToken = tokenTime + 55 * 60 * 1000

   // User must have been active AFTER token was issued (not at login) AND within first 55 minutes
   const hasValidActivity = lastActivity > 0 // Must have some activity recorded
   const activityAfterToken = lastActivity > tokenTime // Activity must be after token issued
   const activityWithinWindow = lastActivity <= fiftyFiveMinutesAfterToken // Within 55 minutes

   const wasActiveInFirst55 = hasValidActivity && activityAfterToken && activityWithinWindow

   return wasActiveInFirst55
}

// Function to set up activity tracking
export const initializeActivityTracking = () => {
   const events = ["scroll", "click", "keydown"]

   const handleUserActivity = () => {
      updateLastActivity()
   }

   // Remove existing listeners first to avoid duplicates
   if (window.removeActivityListeners) {
      window.removeActivityListeners()
   }

   // Add event listeners for user activity
   events.forEach((event) => {
      document.addEventListener(event, handleUserActivity, true)
   })

   // Store cleanup function
   window.removeActivityListeners = () => {
      events.forEach((event) => {
         document.removeEventListener(event, handleUserActivity, true)
      })
   }

   // Start automatic token checking
   startTokenCheck()
}

const startTokenCheck = () => {
   // Clear any existing interval
   if (tokenCheckInterval) {
      clearInterval(tokenCheckInterval)
   }

   // Set up new interval to check token every 1 minute
   tokenCheckInterval = setInterval(() => {
      const token = getToken()
      const currentTime = Date.now()
      const storedTokenTime = localStorage.getItem("tokenIssuedTime")
      const tokenTime = storedTokenTime ? parseInt(storedTokenTime) : tokenIssuedTime
      const timeSinceTokenIssued = currentTime - tokenTime
      const minutesSinceTokenIssued = Math.round(timeSinceTokenIssued / 60000)

      if (token && token !== "undefined") {
         // Check if 55 minutes (3,300,000ms) have passed since token was issued
         if (timeSinceTokenIssued >= 3300000) {
            // 55 minutes = 3,300,000 milliseconds

            if (wasActiveInFirst55Minutes()) {
               const now = Date.now()
               const timeSinceLastRefresh = now - lastRefreshTime

               // Only refresh if not currently refreshing AND it's been more than 30 seconds
               if (!isRefreshing && timeSinceLastRefresh > 30000) {
                  lastRefreshTime = now
                  refreshToken(REFRESH_PING)
               }
            }
         }
      } else {
         stopTokenCheck()
      }
   }, 60 * 1000) // Check every 1 minute
}

const stopTokenCheck = () => {
   if (tokenCheckInterval) {
      clearInterval(tokenCheckInterval)
      tokenCheckInterval = null
   }
}

//Post api call to ping to get refresh token and logout the user
export const postApiCall = (url, data) => {
   return Api.post(url, data, {
      headers: getAuthentiationHeaders(1),
   }).then(_checkStatus)
}

export const getAuthentiationHeaders = (flag = null) => {
   const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      user_type: localStorage.getItem("userType"),
   }

   if (flag == null && isLoggedIn()) {
      headers["Authorization"] = "Bearer " + getToken()
      headers["access_token"] = localStorage.getItem("id_token")
   }

   return headers
}
// performs api calls to fecth all info data
export const fetchAPIData = (url, options) => {
   return Api.get(url, {
      headers: getAuthentiationHeaders(),
      ...options,
   }).then(_checkStatus)
}

//decode and set the access token , auth token and other params to local storage
export const setTokenData = (data) => {
   if (data.access_token) {
      var accessToken = jwtDecode(data.access_token)
      localStorage.setItem("expiry", accessToken.exp)
      localStorage.setItem("id_token", data.access_token)
      const userType = localStorage.getItem("userType")
      if (userType === "PG") {
         var userName = accessToken.FirstName + " " + accessToken.LastName
         localStorage.setItem("User", userName)
         localStorage.setItem("UserId", accessToken.Username)
      } else {
         localStorage.setItem("User", accessToken.name)
         localStorage.setItem("UserId", accessToken.preferred_username)
      }
   }
   if (data.authToken) localStorage.setItem("authToken", data.authToken)
   var authToken = jwtDecode(data.authToken)
   var secAuthority = authToken.securityAuthorities
   var employee = authToken.employee
   if (authToken.fromPreferenceDate) {
      localStorage.setItem("fromPreferenceDate", authToken.fromPreferenceDate)
   }

   if (authToken.toPreferenceDate) {
      localStorage.setItem("toPreferenceDate", authToken.toPreferenceDate)
   }
   if (authToken.hir_compliant) {
      localStorage.setItem("hir_compliant", authToken.hir_compliant)
   }

   if (employee) {
      localStorage.setItem("employee", btoa(employee))
   }

   const userType = localStorage.getItem("userType")
   if(!authToken.isUserTrained && userType === "SBM"){
      localStorage.setItem("isUserTrained",authToken.isUserTrained);
   }

   if (authToken.expirationDate) {
      localStorage.setItem("expirationDate", authToken.expirationDate)
   }
   const emailPreference = authToken.preference
   if (authToken.preference) {
      sessionStorage.setItem("emailNotifications", emailPreference)
   }

   if (secAuthority != null) {
      var roleName = ""
      for (var i = 0; i < secAuthority.length; i++) {
         if (secAuthority[i].authority.includes("Spec Reader Contract Manufacturer")) {
            roleName = "CM"
            break
         }
         if (secAuthority[i].authority.includes("Spec Reader Supplier")) {
            roleName = "SP"
         }
      }
      localStorage.setItem("role", roleName)
   }

   if (data.refresh_token) localStorage.setItem("refresh_token", data.refresh_token)
   tokenIssuedTime = Date.now()
   localStorage.setItem("tokenIssuedTime", tokenIssuedTime.toString())

   // Set the authenticated user in Faro so the userId appears in all traces/spans
   try {
      const faroUserId = localStorage.getItem("UserId")
      const faroUserType = localStorage.getItem("userType")
      if (faroUserId && faro?.api) {
         faro.api.setUser({
            id: faroUserId,
            attributes: {
               userType: faroUserType || "unknown",
               role: localStorage.getItem("role") || "unknown",
            },
         })
      }
   } catch (e) {
      // faro not yet initialized — silently skip
   }

   //  IMPORTANT: Clear previous activity so login doesn't count as user activity
   lastActivityTime = 0
   localStorage.removeItem("lastActivityTime")
   initializeActivityTracking()
}

//to check if the auth token exists in local storage
// Replace both isLoggedIn and isLoggedIn1 with this single function
export const isLoggedIn = (calledFrom, value, calledFrom1, value1) => {
   const token = getToken()
   let flag = isTokenExpired()

   if (token !== "undefined" && token && flag !== 0) {
      if (flag === 1) {
         if (wasActiveInFirst55Minutes()) {
            refreshToken(REFRESH_PING)
         }
      }
      return true
   } else {
      // Handle different calling scenarios
      if (calledFrom && calledFrom === "gcas") {
         localStorage.setItem("calledFrom", "gcas")
         localStorage.setItem("gcas", value)
      } else if (calledFrom && calledFrom === "objectName") {
         localStorage.setItem("calledFrom", "objectName")
         localStorage.setItem("objectName", value)

         if (calledFrom1 && calledFrom1 === "downloadtype") {
            localStorage.setItem("calledFrom1", "downloadtype")
            localStorage.setItem("downloadtype", value1)
         }
      } else if (calledFrom && calledFrom === "unreleasedSearch") {
         localStorage.setItem("calledFrom", "unreleasedSearch")
         localStorage.setItem("unreleasedPartName", value)
      } else {
         // Clear all stored values if not matching expected scenarios
         localStorage.removeItem("calledFrom")
         localStorage.removeItem("gcas")
         localStorage.removeItem("calledFrom1")
         localStorage.removeItem("objectName")
         localStorage.removeItem("downloadtype")
         localStorage.removeItem("unreleasedPartName")
      }
      return false
   }
}

//clear the local storage and navigate the user to logout
export const notAuthorized = (object) => {
   clearSessionAndLocalStorage()
}

// Retrieves the user token from localStorage
export const getToken = () => {
   return localStorage.getItem("authToken")
}

export const getProfile = () => {
   return getToken()
}

// Raises an error in case response status is not a success
const _checkStatus = (response) => {
   if (response.status >= 200 && response.status < 300) {
      // Success status lies between 200 to 300
      return response
   } else {
      var error = new Error(response.statusText)
      error.response = response
      throw error
   }
}

// To check if the token is expired or not
export const isTokenExpired = () => {
   const exp = localStorage.getItem("expiry")
   const currentTime = Math.trunc(Date.now() / 1000)
   const timeUntilExpiry = exp - currentTime
   if (exp < currentTime) {
      return 0
      //when token is expired
   } else if (timeUntilExpiry <= 300) {
      return 1
      //when token is about to expire in 5 minutes
   } else {
      return 2
      //when token is active
   }
}

// To refresh the token
export const refreshToken = async (url) => {
   const token = localStorage.getItem("refresh_token")
   if (isRefreshing) {
      return
   }
   isRefreshing = true
   try {
      const response = await postApiCall(`${url}?refresh_token=${token}`)
      setTokenData(response.data)
   } catch (error) {
      clearSessionAndLocalStorage()
   } finally {
      isRefreshing = false
   }
}



export const logout = async (object) => {
   var pathName = ""
   // Add safety check for object and location
   if (object && object.location && object.location.pathname) {
      pathName = object.location.pathname.split("/")[1]
   }
   try {
      if (localStorage.getItem("UserId")) {
         const response = await LogLogOut_Details(
            LOG_LOGOUT_API,
            localStorage.getItem("UserId"),
            pathName,
         )
         if (response && response.status === 200) {
            console.log("log out successfully from app.", response)
         }
      }
   } catch (error) {
      console.log("Error", ` API request failed: ${error}`)
   } finally {
      clearSessionAndLocalStorage()
   }
}

// Simplified - just like your old code
const clearSessionAndLocalStorage = () => {
   try {
      stopTokenCheck()
      if (window.removeActivityListeners) {
         window.removeActivityListeners()
      }
      localStorage.removeItem("lastActivityTime")
      localStorage.removeItem("tokenIssuedTime")
      localStorage.removeItem("id_token")
      localStorage.removeItem("User")
      localStorage.clear()
      sessionStorage.clear()
      
      
      window.history.replaceState(null, "", "/")
      window.location.replace("/")  
   } catch (error) {
      console.log("Error", ` API request failed: ${error}`)
   }
}

//save the user prefrences
export const savePref = (url, name, list) => {
   const data = {
      id: { userId: localStorage.getItem("UserId"), objectName: name },
      userOnAccess: list,
   }
   return Api.post(url, data, {
      headers: getAuthentiationHeaders(1),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

//AllInfo pdf formation
export const AllInfoPdfGenerate = (url, type, pdfData, objectID, view) => {
   const data = {
      objectType: type,
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "",
      data: pdfData,
      objectID: objectID,
      view: view,
   }
   return Api.post(url, data, {
      responseType: "arraybuffer",
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const GenDocFileDownload = (
   url,
   fileName,
   filePath,
   fileType,
   attributes,
   headerContent,
   Title,
   calledFrom,
   requestFrom,
) => {
   const data = {
      filename: fileName,
      filepath: filePath,
      fileType: fileType,
      attributes: attributes,
      headerContent: headerContent,
      title: Title ? Title : "",
      calledFrom: calledFrom ? calledFrom : "",
      requestFrom: requestFrom ? requestFrom : "",
   }

   return Api.post(url, data, {
      responseType: "blob",
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const LogLogOut_Details = (url, userName, page) => {
   const data = {
      userName: userName,
      page: page,
   }
   return Api.post(url, data, {
      headers: getAuthentiationHeaders(1),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const DSMReportGenerate = (url, data) => {
   return Api.post(url, data, {
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}
export const DSMDelete = (url, data) => {
   return Api.post(url, data, {
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const MoveRemoveAPI = (url, data) => {
   return Api.put(url, data, {
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const EmailPreference = (url, data) => {
   return Api.put(url, data, {
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const EBPViewPdfDownload = (url, data) => {
   return Api.post(url, data, {
      responseType: "arraybuffer",
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const EBPIDsForEmail = (url, data) => {
   return Api.put(url, data, {
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}
export const PutData = (url, data) => {
   return Api.put(url, data, {
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const highlyConnectedMessage = (url, data) => {
   return Api.put(url, data, {
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const UpdateTrainingStatus = (url, isUserTrained) => {
   return Api.put(`${url}/${isUserTrained}`, null, {
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const UserManualDownload = (url) => {
   return Api.get(url, {
      responseType: "blob",
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}

export const DIRECTPDFDOWNLOAD = (url) => {
   return Api.get(url, {
      responseType: "blob",
      headers: getAuthentiationHeaders(),
   }).then((res) => {
      return Promise.resolve(res)
   })
}
